import "@images/Sign-Seal_Red_with_white.png"
import "@images/three-dots.svg"

/*
<% images_glob = Rails.application.root.join('app', 'frontend', 'application', 'media', 'images', '**', '*.{png,svg}') %>
<% Dir.glob(images_glob).each do |image| %>
  import '<%= image %>';
<% end %>
*/